// extracted by mini-css-extract-plugin
export default {"strikeThrough":"strikeThrough__ZGE5Y","baseCreditPrice":"baseCreditPrice__YjY5M","discountText":"discountText__MWYxN"};